import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingStates = new Map<string, BehaviorSubject<boolean>>();

  setLoading(key: string, loading: boolean): void {
    if (!this.loadingStates.has(key)) {
      this.loadingStates.set(key, new BehaviorSubject<boolean>(false));
    }
    this.loadingStates.get(key)!.next(loading);
  }

  getLoading(key: string): Observable<boolean> {
    if (!this.loadingStates.has(key)) {
      this.loadingStates.set(key, new BehaviorSubject<boolean>(false));
    }
    return this.loadingStates.get(key)!.asObservable();
  }

  getAnyLoading(keys: string[]): Observable<boolean> {
    const observables = keys.map(key => this.getLoading(key));
    return combineLatest(observables).pipe(
      map(states => states.some(state => state))
    );
  }

  getAllLoading(): Observable<boolean> {
    const allObservables = Array.from(this.loadingStates.values());
    if (allObservables.length === 0) {
      return new BehaviorSubject<boolean>(false).asObservable();
    }
    return combineLatest(allObservables).pipe(
      map(states => states.some(state => state))
    );
  }

  clearLoading(key: string): void {
    if (this.loadingStates.has(key)) {
      this.loadingStates.get(key)!.next(false);
    }
  }

  clearAllLoading(): void {
    this.loadingStates.forEach(subject => subject.next(false));
  }
}
